import { create } from "zustand"

export const createStore = create((set) => ({
    user: JSON.parse(localStorage.getItem("user")),

    setCredentials: (user) => set({ user }),
    logOut: () => set({ user: null })
}))